import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";import BannerImg from "../assets/Images/banner5-1920x450.png";

import BottomLogoImg from "../assets/Images/bottom-logo.png";

import "./SocietyNewsPageDetail.scss";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import axios from "axios";

const SocietyNewsPageDetail = () => {
  const { t } = useTranslation();

  const [blogs, setBlogs] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    console.log("Fetching blog with ID:", id);
    const fetchData = async () => {
      try {
        const response = await axios.get("https://www.hkarbsoc.org.hk:9003/api/posts/"+id);
        console.log(response.data);
        setBlogs([response.data]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [id]);

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res responsive-title">
          <h1 className="banner-main-title">{t("society_news_page_header")}</h1>
          <p className="banner-subtitle">{t("society_news_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_society_news_page_link1")}</Link>
        <span>{t("breadcrumbs_society_news_page_span")}</span>
        <Link>{t("breadcrumbs_society_news_page_link2")}</Link>
      </Breadcrumbs>

      <div className="main-container-society-news">

        { blogs.length > 0 && blogs.map((blog, index) => (
            <article key={index} className="news-detail-article">
              <div className="news-detail-header">
                <img src={`${blog?.featuredImage}`} alt={blog?.title} className="news-detail-image" />
                <div className="news-detail-meta">
                  <h1 className="news-detail-title">{t(blog?.title ? blog.title : "")}</h1>
                  <span className="news-detail-date">
                    {blog?.createdAt ? new Date(blog.createdAt ? blog.createdAt : "").toLocaleDateString() : ""}
                  </span>
                </div>
              </div>
              <div
                className="news-detail-content"
                dangerouslySetInnerHTML={{ __html: blog?.content || "" }}
              />
            </article>
          ))}
      </div>

      <div className="temporary">
        <img src={BottomLogoImg} alt="" />
      </div>
      <Footer />
    </>
  );
};

export default SocietyNewsPageDetail;
